import { useState } from 'react';
import useFetch from '../../../../hooks/useFetch';
import { ServiceEvents } from '../../shared/interfaces';
import { buildEndpointIntranetCompany } from '../../EndPoints';
import { EventProgram, EventProgramFilters } from '../../../models/EventProgram';

const useEventProgramService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetEventProgramsByEvent, setFetchingGetEventProgramsByEvent] = useState(false);
    const [fetchingShowEventProgram, setFetchingShowEventProgram] = useState(false);
    const [fetchingStoreEventProgram, setFetchingStoreEventProgram] = useState(false);
    const [fetchingEditEventProgram, setFetchingEditEventProgram] = useState(false);
    const [fetchingUpdateEventProgram, setFetchingUpdateEventProgram] = useState(false);
    const [fetchingDeleteEventProgram, setFetchingDeleteEventProgram] = useState(false);
    const [fetchingActiveEventProgram, setFetchingActiveEventProgram] = useState(false);

    const getEventProgramsByEvent = (event_id: number,
        eventProgramFilters: EventProgramFilters,
        events: ServiceEvents = {}
    ) => {
        const queryString = Object.entries(eventProgramFilters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        doGet({
            ...events,
            type: 'company',
            url: `${buildEndpointIntranetCompany(`events/event-programs/${event_id.toString()}/by-event`)}?${queryString}`,
            setFetching: setFetchingGetEventProgramsByEvent
        });
    };

    const showEventProgram = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            type: 'company',
            url: `${buildEndpointIntranetCompany(
                `events/event-programs/${id.toString()}/show`
            )}`,
            setFetching: setFetchingShowEventProgram
        });
    };

    const storeEventProgram = (eventProgram: EventProgram, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: `${buildEndpointIntranetCompany(`events/event-programs/store`)}`,
            type: 'company',
            body: eventProgram,
            setFetching: setFetchingStoreEventProgram
        });
    };

    const editEventProgram = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            type: 'company',
            url: `${buildEndpointIntranetCompany(
                `events/event-programs/${id.toString()}/edit`
            )}`,
            setFetching: setFetchingEditEventProgram
        });
    };

    const updateEventProgram = (
        id: number,
        eventProgram: EventProgram,
        events: ServiceEvents = {}
    ) => {
        doPut({
            ...events,
            type: 'company',
            url: `${buildEndpointIntranetCompany(
                `events/event-programs/${id.toString()}/update`
            )}`,
            body: eventProgram,
            setFetching: setFetchingUpdateEventProgram
        });
    };

    const deleteEventProgram = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            type: 'company',
            url: `${buildEndpointIntranetCompany(
                `events/event-programs/${id.toString()}/delete`
            )}`,
            setFetching: setFetchingDeleteEventProgram
        });
    };

    const activeEventProgram = (id: number, active: boolean, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            type: 'company',
            url: `${buildEndpointIntranetCompany(
                `events/event-programs/${id.toString()}/active`
            )}`,
            body: { active: active },
            setFetching: setFetchingActiveEventProgram
        });
    };

    return {
        fetchingGetEventProgramsByEvent,
        fetchingShowEventProgram,
        fetchingStoreEventProgram,
        fetchingEditEventProgram,
        fetchingUpdateEventProgram,
        fetchingDeleteEventProgram,
        fetchingActiveEventProgram,
        getEventProgramsByEvent,
        showEventProgram,
        storeEventProgram,
        editEventProgram,
        updateEventProgram,
        deleteEventProgram,
        activeEventProgram
    };
};

export default useEventProgramService;
